var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zdy-dragging-page" }, [
    _c(
      "div",
      { staticClass: "search-bar" },
      [
        _c("el-input", {
          staticStyle: { width: "300px", "margin-right": "10px" },
          attrs: { placeholder: "请输入名称搜索", clearable: "" },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.handleFilter($event)
            },
          },
          model: {
            value: _vm.listQuery.name,
            callback: function ($$v) {
              _vm.$set(_vm.listQuery, "name", $$v)
            },
            expression: "listQuery.name",
          },
        }),
        _vm._v(" "),
        _c(
          "el-select",
          {
            staticStyle: { width: "200px", "margin-right": "10px" },
            attrs: { placeholder: "请选择状态搜索", clearable: "" },
            on: { change: _vm.handleFilter },
            model: {
              value: _vm.listQuery.enable,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "enable", $$v)
              },
              expression: "listQuery.enable",
            },
          },
          [
            _c("el-option", { attrs: { label: "启用", value: 1 } }),
            _vm._v(" "),
            _c("el-option", { attrs: { label: "禁用", value: 0 } }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: { type: "primary", icon: "el-icon-search" },
            on: { click: _vm.handleFilter },
          },
          [_vm._v("搜索")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: { type: "primary", icon: "el-icon-plus" },
            on: { click: _vm.handleCreate },
          },
          [_vm._v("新增")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-container" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.list,
              border: "",
              fit: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "id", label: "ID", width: "80", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "name", label: "名称", "min-width": "120" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "type",
                label: "类型",
                width: "100",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type:
                              Number(scope.row.type) === 1
                                ? "primary"
                                : "success",
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                Number(scope.row.type) === 1 ? "主页" : "其他页"
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "pageIndex",
                label: "页面标识",
                "min-width": "120",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "urlLink", label: "链接地址", "min-width": "150" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.urlLink
                        ? _c(
                            "div",
                            { staticClass: "url-cell" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "url-text",
                                  attrs: { title: scope.row.urlLink },
                                },
                                [
                                  _vm._v(
                                    _vm._s(scope.row.urlLink) +
                                      "?pageIndex=" +
                                      _vm._s(scope.row.pageIndex)
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("el-button", {
                                staticClass: "copy-btn",
                                attrs: {
                                  type: "text",
                                  icon: "el-icon-document-copy",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.copyUrl(
                                      scope.row.urlLink +
                                        "?pageIndex=" +
                                        scope.row.pageIndex
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _c("span", [_vm._v("-")]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "enable",
                label: "发布状态",
                width: "100",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-switch", {
                        attrs: {
                          "active-color": "#13ce66",
                          "inactive-color": "#ff4949",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.handleStatusChange(scope.row)
                          },
                        },
                        model: {
                          value: scope.row.enable,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "enable", $$v)
                          },
                          expression: "scope.row.enable",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "createTime",
                label: "创建时间",
                width: "180",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm._f("parseTime")(
                              scope.row.createTime,
                              "{y}-{m}-{d} {h}:{i}:{s}"
                            )
                          ) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "updateTime",
                label: "更新时间",
                width: "180",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm._f("parseTime")(
                              scope.row.updateTime,
                              "{y}-{m}-{d} {h}:{i}:{s}"
                            )
                          ) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "操作", width: "240", fixed: "right" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.handleUpdate(scope.row)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.handleCopy(scope.row)
                            },
                          },
                        },
                        [_vm._v("复制")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.handleDelete(scope.row)
                            },
                          },
                        },
                        [_vm._v("删除")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.listQuery.page,
                "page-sizes": [10, 20, 50, 100],
                "page-size": _vm.listQuery.limit,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }